goog.provide('el8.appchart.letters.selectRelatedNote');

goog.require('el8.uiwidget.QuickSelectDialog');


el8.appchart.letters.selectRelatedNote = (function() {

    var module = {};

    module.show = function(noteIds, callbackFn) {
        
        var buttonList = noteIds.map(function(id) {
            var note = el8.ptdata.fetchById(id);
            var noteDate = note.getChartFeedDate().asString();
            var description = note.getDescription();
            return noteDate + ' - ' + description;
        });
        buttonList.push('Cancel');

        var that = new el8.uiwidget.QuickSelectDialog({
            title: 'Add Referral Letter to Draft Note?',
            callbackFn: function(index) {
                if (index === noteIds.length) { // the Cancel button
                    that.destroy();
                    return;
                }
                callbackFn(noteIds[index]);
                that.destroy();
            },
            list: buttonList
        });
        that.show();
    };

    return module;

})();

